import React, { Component } from "react";
import { toast } from "react-toastify";
import { withFirebase } from "../Firebase";

const INITIAL_STATE = {
  passwordOne: "",
  passwordTwo: "",
  error: null,
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { passwordOne } = this.state;

    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        toast.error(error.message);
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    let passwordOne = this.state.passwordOne;
    let passwordTwo = this.state.passwordTwo;

    const isInvalid =
      passwordOne !== passwordTwo || passwordOne === "";

    return (
      <form onSubmit={this.onSubmit}>
        <div className="form-group">
          <label htmlFor="inputPasswordOne">{this.props.t("auth.new-password")}</label>
          <input
            id="inputPasswordOne"
            name="passwordOne"
            value={passwordOne}
            className="form-control"
            onChange={this.onChange}
            type="password"
            placeholder={this.props.t("auth.new-password")}
          />
        </div>
        <div className="form-group">
          <label htmlFor="inputPasswordTwo">{this.props.t("auth.confirm-new-password")}</label>
          <input
            id="inputPasswordTwo"
            name="passwordTwo"
            value={passwordTwo}
            className="form-control"
            onChange={this.onChange}
            type="password"
            placeholder={this.props.t("auth.confirm-new-password")}
          />
        </div>
        <button type="submit"
          className="btn btn-primary"
          disabled={isInvalid}>
          {this.props.t("auth.btn-change-password")}
        </button>
      </form>
    );
  }
}

export default withFirebase(PasswordChangeForm);
